import './components/tabs-component-pd';
import { setCookie, getCookie, isCookieValid } from './utils/cookies';

import "./core/style-quiz";
import "./core/style-quiz-giftcard";
import "./core/style-quiz-giftcard-executive";
import './core/magnolia-giftcard-quiz';
import "./snippets/video-modal";


window.manageCookie = {
    set: setCookie,
    get: getCookie,
    is:  isCookieValid
};